import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=d41b0a0c&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"
import style0 from "./Spaces.vue?vue&type=style&index=0&id=d41b0a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41b0a0c",
  null
  
)

export default component.exports